module.exports = __webpack_public_path__ + "img/cat3.5bbaf041.png";